export default __webpack_public_path__ + "static/media/gallery_05.bd4f72be.jpg";